import cx from 'classnames';
import { useIntl } from '@pass-frontend/common/i18n';
import { Geolocation } from '@pass-frontend/data-access/common/edge';
import { useStandaloneBreakpoints } from '@pass-frontend/features/standalone/data-bridge';
import { getDistanceFromSelectedGym } from './gyms-search-helper';
import {
  StyledGymsDetailsWrapper,
  StyledDetailsText,
  StyledImage,
  StyledSelectedGymDistance,
  StyledTierName,
} from './gyms-search-styles';
import LocationMarkerSVG from './location-marker';

export interface SelectedGymsDetails {
  name: string;
  location: Geolocation | undefined;
  image: string | undefined;
  fromCoordinates?: Coordinates | undefined;
  offeringId: string;
  startsAtTierName: string | undefined;
}

export interface Coordinates {
  latitude: number;
  longitude: number;
}

export const GymsDetailsView = (props?: SelectedGymsDetails) => {
  const { t } = useIntl();

  const { isDesktop } = useStandaloneBreakpoints();

  return (
    <div className="is-display-flex is-align-items-center">
      <StyledImage className="is-display-flex is-align-items-center">
        <img
          src={props?.image || 'images/default-gym-logo.svg'}
          alt={props?.name}
        ></img>
      </StyledImage>
      <StyledGymsDetailsWrapper>
        <StyledDetailsText className="has-text-gray-1 is-body-1-bold">
          {props?.name}
        </StyledDetailsText>
        <StyledDetailsText className="is-body-3-regular">
          {props?.location?.address}
        </StyledDetailsText>
        <StyledDetailsText className="is-body-3-regular">
          {props?.location?.city +
            ', ' +
            props?.location?.state +
            ' ' +
            props?.location?.zipcode}
        </StyledDetailsText>
        {props?.startsAtTierName && !isDesktop && (
          <StyledTierName
            className={cx(
              props?.startsAtTierName,
              'is-sm-1-bold has-text-gray-1',
            )}
          >
            {t('gymSearch.gymCard.StartsAtTier', {
              tierName: props?.startsAtTierName,
            })}
          </StyledTierName>
        )}
        <StyledSelectedGymDistance className="is-sm-1-bold has-text-blue-2 is-display-flex is-align-items-center">
          <LocationMarkerSVG width="10px" height="30px" />
          <span>
            {t('gymsSearch.details.distance', {
              distance: getDistanceFromSelectedGym(
                props?.fromCoordinates,
                props?.location,
              ),
            })}
          </span>
        </StyledSelectedGymDistance>
      </StyledGymsDetailsWrapper>
    </div>
  );
};
